import { render } from "./ImportJson.vue?vue&type=template&id=036cbf28&scoped=true"
import script from "./ImportJson.vue?vue&type=script&lang=js"
export * from "./ImportJson.vue?vue&type=script&lang=js"

import "./ImportJson.vue?vue&type=style&index=0&id=036cbf28&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036cbf28"]])

export default __exports__